import type { ReactElement } from "react"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { Components } from "react-markdown"
import BaseMarkdown from "../Base"

interface Props {
  children: string
  components?: Components
}

function Tile({ children, components }: Props): ReactElement<Props> {
  const markdownOverrides: Components = {
    ...getBaseMarkdownOverrides({
      typography: "small1",
      boldTypography: "small4",
      pushSpace: 2.5,
    }),
  }

  return (
    <BaseMarkdown components={components || markdownOverrides}>
      {children}
    </BaseMarkdown>
  )
}

export default Tile
